export default __webpack_public_path__ + "static/media/iconList.c994931b.svg";